import { Injectable } from '@angular/core';
import { ApiRequestService, apiEndpoints, ErrorResponse } from './api-request.service';
import { LocalStorageService, AUTH_TOKEN, CURRENT_USER } from './local-storage.service';
import { ApiLoginResponseModel } from '../models/login-response.model';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CleanupService } from './cleanup.service';
import { AppSettingsService } from './app-settings.service';
import { ResetPasswordModel } from '../models/reset-password.model';
import { NotifyService } from './notify.service';
import { UserProfileService } from './user-profile.service';
import { finalize } from 'rxjs/operators';
import { tap, catchError, throwError } from 'rxjs';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public errorHandler$ = new Subject<string>();

    constructor(
        private _apiRequestService: ApiRequestService,
        private _localStorageService: LocalStorageService,
        private _cleanupService: CleanupService,
        private _router: Router,
        private _appSettingsService: AppSettingsService,
        private _userProfileService: UserProfileService,
        private _notifyService: NotifyService) { }


    login(username: string, password: string) {
        this._appSettingsService.isLoading.set(true);
        return this._apiRequestService.submitPostRequest(apiEndpoints.login, { username, password }).pipe(
            tap(response => {
                const { token, user } = response.data;

                // Salvare token si user
                this._localStorageService.setValue(AUTH_TOKEN, token);
                this._localStorageService.setValue(CURRENT_USER, JSON.stringify(user));

                // Setare user in UserProfileService
                this._userProfileService.currentUser$.next(user);

                // Incarcare permisiuni din API
                this._userProfileService.loadPermissions().subscribe();
            })
        );
    }

    sendEmailResetLink(email: string) {
        this._apiRequestService.submitPostRequest(apiEndpoints.emailResetLink, { email }).subscribe({
            next: () => { },
            error: error => this._reportError(<ErrorResponse>error.error)
        })
    }

    resetPassword(payload: ResetPasswordModel) {
        this._apiRequestService.submitPostRequest(apiEndpoints.resetPassword, payload).subscribe({
            next: () => { },
            error: error => this._reportError(<ErrorResponse>error.error)
        });
    }

    logout() {
        this._localStorageService.deleteValue(AUTH_TOKEN);
        this._localStorageService.deleteValue(CURRENT_USER);
        this._userProfileService.currentUser$.next(null);
        this._router.navigate(['/login']);
    }

    private _handleLoginResponse(response: ApiLoginResponseModel) {
        this.errorHandler$.next(undefined);

        // Salvare token si user in LocalStorage
        this._localStorageService.setValue(AUTH_TOKEN, response.data.token);
        this._localStorageService.setValue(CURRENT_USER, JSON.stringify(response.data.user));

        // Actualizare UserProfileService cu userul curent
        this._userProfileService.currentUser$.next(response.data.user);

        // Navigare la dashboard
        this._router.navigate(['/dashboard']);
        this._appSettingsService.isLoading.set(false);
    }

    private _handleLogoutResponse() {
        this._localStorageService.deleteValue(AUTH_TOKEN);
        this._localStorageService.deleteValue(CURRENT_USER);
        this._cleanupService.resetAllSubjects();
        this._router.navigate(['/login']);
    }

    private _reportError(response: ErrorResponse) {
        this.errorHandler$.next(response.message);
        this._appSettingsService.isLoading.set(false);
    }
}
